var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"logo-title-block"},[_c('h1',[_vm._v("Пусть робот управляет твоей парковкой")]),_c('img',{staticClass:"logo-title-block__img",attrs:{"src":`${_vm.publicPath}images/logo/logo-robot-small.png`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }